export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.10.6-1256.28",
  commitId: "60ae47e26ffdca8ff437f52de7e0b4159e811585",
  commitTime: "2026-10-06T12:56:28.000Z",
});
